"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogCloseMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _DialogClose = require("../components/DialogClose/DialogClose.styles");
/** @mixin dialogCloseMixin */
/**
 * Positions the close button on dialog components.
 *
 * @example
 * import { dialogCloseMixin, CloseButton } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${dialogCloseButton}
 * `;
 *
 * <Component>
 *      <CloseButton />
 * </Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var dialogCloseMixin = function dialogCloseMixin(props) {
  return (0, _styledComponents.css)(["position:relative;& ", "{position:absolute;z-index:", ";}"], _DialogClose.StyledDialogClose, (0, _styledToken.default)('zIndices.dialog')(props));
};
exports.dialogCloseMixin = dialogCloseMixin;